export enum PermissionResources {
    UNKNOWN = 0,
    FULL_ACCESS = 1,
    FINANCES = 2,
    USER_MANAGEMENT = 3,
    TRANSACTIONS = 4,
    RENT_COLLECTION = 5
}
